import { render, staticRenderFns } from "./MATEditModal.vue?vue&type=template&id=a7bc2912&scoped=true"
import script from "./MATEditModal.vue?vue&type=script&lang=js"
export * from "./MATEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7bc2912",
  null
  
)

export default component.exports